module.exports = __webpack_public_path__ + "static/img/so4_4.81aadbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so4_4.jpg
// module id = Jl6d
// module chunks = 11